import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import CareerCard from "../CareerCard/CareerCard";
import ReporteeDetails from "../Reportees/ReporteeDetails";
import DashboardNewPage from "../DashboardMain/DashboardMain";
import EmployeeSearchWrapper from "../CareerCard/EmployeeSearchWrapper";
import "./Dashboard.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "primeicons/primeicons.css";
import { PATH_CAREER_CARD, PATH_DASHBOARD, PATH_EMPLOYEEHIERARCHY, PATH_GETDETAILS, PATH_LOGIN, PATH_LOGOUT, PATH_MAINDASHBOARD, PATH_NOACCESS, PATH_NOTFOUND, PATH_RELOGIN, PATH_REPORTEES } from "../../constants/routes";
import axios from "axios";
import { Route, Routes, useNavigate } from "react-router-dom";
import SessionExpiredAlert from "../common/sessionexpiredalert";
import RouteMasker from "../common/routeMasker";
import PublicRoute from "../../routes/publicRoutes";
import ProtectedRoute from "../../routes/protectedRoutes";
import NotFound from "../../utils/NotFound";
import NoAccess from "../../utils/NoAccess";
import Login from "../Login/Login";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const [showReportee, setShowReportee] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showNewDashboard, setShowNewDashboard] = useState(false);
  const [showOrgChart, setShowOrgChart] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [username, setuserName] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  // const [hassecgroup, sethassecgroup] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isAuthenticated, setisAuthenticated] = useState(false);
  // const [errorStatus, setErrorStatus] = useState("");
  
  const empOracleDetails = useSelector(
    (state: RootState) => state.empOracleDetails
  );

  const empDetails = useSelector((state: RootState) => state.empDetails);

  const [imageUrl, setImageUrl] = useState("/profile.png");
  const [sideimageUrl] = useState("/Logo.png");


  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest(".user-dropdown")) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    getDetails();
  }, []);


  const getDetails = async () => {
    const path = window.location.pathname;
    let url = process.env.REACT_APP_MIDDLEWARE_API_BASE_URL + PATH_GETDETAILS;

    const headers = {
      "Content-Type": 'application/json',
    }
    const res: any = await new Promise((resolve, reject) => {
      try {
        setShowLoader(true);
        axios.get(url, { headers: headers, withCredentials: true })
          .then((res: any) => {
            setShowLoader(false);
            resolve(res);
          })
          .catch((err) => {
            setShowLoader(false);
            resolve(err);
          });
      } catch (error) {
        setShowLoader(false);
        reject(error);
      }
    });
    if (res?.data?.HttpStatus === 200) {
      if (res?.data?.Data?.Permissions) {
        setuserName(res?.data?.Data?.User);
        decodeUserRoles(res?.data?.Data?.Permissions);
        if (res?.data?.Data?.Permissions) {
          setisAuthenticated(res?.data?.Data?.Active);
          setSessionExpired(!res?.data?.Data?.Active);
          if (res?.data?.Data?.Permissions) {
            if (isAdmin) {
              (path === "/" || path === "") ? navigate(PATH_EMPLOYEEHIERARCHY) : navigate(path);
            }
            else if (isUser) {
              (path === "/" || path === "") ? navigate(PATH_CAREER_CARD) : navigate(path);
            }
          }
        }
        else {
          navigate(PATH_NOACCESS);
        }
      }
      else {
        // sethassecgroup(false);
        navigate(PATH_NOACCESS);
      }
    } else {
      if (res?.response?.status === 401) {
        // setErrorStatus(res?.response?.data?.message?.message);
      }
      setisAuthenticated(false);
      navigate(PATH_LOGIN);
    }
  }

  const deobfuscateString = (obfuscated: string) => {
    if (!obfuscated) return '';

    let chars = obfuscated.split('');
    chars = chars.slice(0, -2);

    if (chars.length >= 10) chars.splice(10, 1);
    if (chars.length >= 6) chars.splice(6, 1);
    if (chars.length >= 2) chars.splice(2, 1);

    return chars.join('');
  };

  const decodeUserRoles = (encodedRoles: string) => {
    try {
      const decodedString = atob(deobfuscateString(encodedRoles));
      const roleParts = decodedString.split(':');
      setIsAdmin(roleParts[0] === '1');
      setIsUser(roleParts[1] === '1');
    } catch (error) {
      setIsAdmin(false);
      setIsUser(false);
    }
  };

  const handleReporteeSelected = (reporteeEmail: string) => {
    setShowReportee(false);
  };

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const handleConfirmLogout = () => {
    setShowLogoutConfirm(false);
    setShowLoader(true);
    
    // Clear browser-side data before redirecting to backend logout
    try {
      localStorage.clear();
      sessionStorage.clear();
      // Clear accessible cookies from browser side
      document.cookie.split(";").forEach(cookie => {
        const name = cookie.split("=")[0].trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      });
    } catch (error) {
      console.warn('Browser cleanup error during logout:', error);
    }

    // Direct navigation — backend will clear httpOnly cookies and redirect to SSO logout
    const logoutUrl = process.env.REACT_APP_MIDDLEWARE_API_BASE_URL + PATH_LOGOUT;
    window.location.href = logoutUrl;
  };

  const handleCancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  useEffect(() => {
    // if (empOracleDetails.data) {
    //   const oracleMsg = (empOracleDetails.data as any)?.response?.message;

    //   setJobtitle(
    //     oracleMsg?.Job_Code
    //       ? oracleMsg.Job_Code.includes(".")
    //         ? oracleMsg.Job_Code.split(".")[1].trim()
    //         : oracleMsg.Job_Code
    //       : ""
    //   );

    //   setName(
    //     oracleMsg
    //       ? oracleMsg?.Employee_FirstName + " " + oracleMsg?.Employee_LastName
    //       : "N/A"
    //   );
    // }
    if (empDetails.data) {
      setImageUrl(empDetails.data.image || "/profile.png");
    }
  }, [empOracleDetails.data, empDetails.data]);

  const handlerelogin = () => {
    setShowLoader(true);
    window.location.replace(process.env.REACT_APP_MIDDLEWARE_API_BASE_URL + PATH_RELOGIN);
  }

  return (
    <div className={isAuthenticated ? "dashboard" : "dashboard-bg"}>
      {showLogoutConfirm && (
        <div className="modal-backdrop">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-exclamation-triangle-fill warning-icon" aria-hidden="true"></i>
                Confirm Logout
              </h5>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to logout?</p>
            </div>
            <div className="modal-footer">
              <button className="btn secondary" onClick={handleCancelLogout}>
                Cancel
              </button>
              <button className="btn primary" onClick={handleConfirmLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
      {sessionExpired && (
        <SessionExpiredAlert onRelogin={handlerelogin} />
      )}
      {/* Enhanced Sidebar */}
      {username !== "" && !sessionExpired &&
        <div className="sidebar">
          <div className="sidebar-header">
            <div className="logo-wrapper">
              <div className="logo">
                {" "}
                <img
                  src={sideimageUrl}
                  alt="Logo"
                  className="mb-4 sidebar-logo"
                  style={{ width: "40px", height: "40px", marginTop: "20px" }}
                />
              </div>
            </div>
          </div>

          <div className="sidebar-nav">
            <div
              className={`nav-item ${!showReportee &&
                !showNewDashboard &&
                !showOrgChart &&
                !isAdmin 
                ? "active"
                : ""
                }`}
              onClick={() => {
                setShowReportee(false);
                setShowNewDashboard(false);
                setShowOrgChart(false);
                navigate(PATH_CAREER_CARD);
              }}
              title="Home"
            >
              <i className="pi pi-home nav-icon" aria-hidden="true"></i>
            </div>

            <div
              className={`nav-item ${showReportee && !showNewDashboard && !showOrgChart ? "active" : ""
                }`}
              onClick={() => {
                setShowReportee(true);
                setShowNewDashboard(false);
                setShowOrgChart(false);
                navigate(PATH_REPORTEES);
              }}
              title="Reportee Details"
            >
              <i className="pi pi-users nav-icon" aria-hidden="true"></i>
            </div>

           { isAdmin && <><div
              className={`nav-item ${showNewDashboard && !showReportee && !showOrgChart ? "active" : ""
                }`}
              onClick={() => {
                setShowReportee(false);
                setShowNewDashboard(true);
                setShowOrgChart(false);
                navigate(PATH_MAINDASHBOARD);
              }}
              title="Dashboard"
            >
              <i className="pi pi-chart-bar nav-icon" aria-hidden="true"></i>
            </div>

            <div
              className={`nav-item ${!showNewDashboard && !showReportee && showOrgChart ? "active" : ""
                }`}
              onClick={() => {
                setShowReportee(false);
                setShowNewDashboard(false);
                setShowOrgChart(true);
                navigate(PATH_EMPLOYEEHIERARCHY);
              }}
              title="Employee Search"
            >
              <i className="bi bi-building nav-icon" aria-hidden="true"></i>
            </div>
            </>}
          </div>

          <div className="sidebar-logout-bottom">
            <div
              className="nav-item logout"
              onClick={handleLogout}
              title="Logout"
            >
              <i className="pi pi-sign-out nav-icon" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      }

      {/* Main Content */}
      <div className="main-content-dashboard">
        {/* Enhanced Header */}
        {username !== "" && !sessionExpired && <div className="main-header">
          
            <div className="header-left">
              <h2 className="app-title">TTEC Talent</h2>
            </div>
            <header className="header">
              <div className="user-dropdown">
                <button
                  className="user-button"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <img src={imageUrl} alt="User" className="user-avatar" />
                  {username && (
                    <>
                      <span className="user-name">Welcome, {username}</span>
                      <i className="pi pi-chevron-down caret" aria-hidden="true"></i>
                    </>
                  )}
                </button>
                {dropdownOpen && (
                  <div className="dropdown-content">
                    <div className="dropdown-header">
                      <img
                        src={imageUrl}
                        alt="User"
                        className="dropdown-avatar"
                      />
                      <div className="dropdown-info">
                        <div className="dropdown-name">{username}</div>
                        {/* <div className="dropdown-role">{jobtitle}</div>{" "} */}
                        {/* optional */}
                      </div>
                    </div>
                    <hr />
                    <button className="dropdown-item" onClick={handleLogout}>
                      <i className="pi pi-sign-out" aria-hidden="true"></i> Logout
                    </button>
                  </div>
                )}
              </div>
            </header>
        </div>}

                         <div className={isAuthenticated ? "contentview" : "content"}>
            <RouteMasker />
            <Routes>
              <Route element={<PublicRoute isAuthenticated={isAuthenticated} />}>
                <Route path={PATH_LOGIN} element={<Login />} />
              </Route>
              <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
                <Route path={PATH_DASHBOARD} element={<Dashboard />} />
                <Route
                  path={PATH_CAREER_CARD}
                  element={<CareerCard empId={"NA"} isAdminView={false} isView={false} username={username}/>}
                />
                <Route
                  path={PATH_REPORTEES}
                  element={<ReporteeDetails username={username}/>} />
               {isAdmin && <><Route
                  path={PATH_MAINDASHBOARD}
                  element={<DashboardNewPage />}
                />
                <Route
                  path={PATH_EMPLOYEEHIERARCHY}
                  element={<EmployeeSearchWrapper username={username}/>}
                /></>}
                <Route path={PATH_NOTFOUND} element={<NotFound />} />
                <Route path={PATH_NOACCESS} element={<NoAccess />} />
              </Route>
            </Routes>
          </div>
      </div>
    </div>
  );
};

export default Dashboard;

